import { render, staticRenderFns } from "./AutoResults.vue?vue&type=template&id=099312bb&scoped=true"
import script from "./AutoResults.vue?vue&type=script&lang=ts"
export * from "./AutoResults.vue?vue&type=script&lang=ts"
import style0 from "./AutoResults.vue?vue&type=style&index=0&id=099312bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099312bb",
  null
  
)

export default component.exports